import React from 'react'

export const SingleQuestion = ({id,text_value,correct}) => {
    return (
        <div className="btn-question" key={id}><input type="radio" key={id} id={id} name="options" className="opt-question" value={correct}/> {text_value} <br/></div>
    )
}
